<template>
  <bs-box-panel showRightButton @on-right="getMore" title="视频监控">
    <div
      class="sn-bs-wrap"
      v-loading="loading"
      element-loading-background="rgba(0, 0, 0, 0.2)"
    >
      <div class="sn-bs-wrap__headerVideo" v-if="!loading && videoList.length">
        <cameraVideo
          ref="cameraVideoRef"
          :farmId="farmId"
          :urlOption="videoList[0]"
          :autoplay="true"
        ></cameraVideo>
      </div>

      <empty v-if="!loading && !videoList.length"></empty>
    </div>
  </bs-box-panel>
</template>

<script>
import cameraVideo from "@/views/bs/Farm/components/CameraVideo/CameraVideo.vue";
import { iotAccess } from "@/api/request/snkd.produce";
import { mapState } from "vuex";
import Empty from "@/components/bs/BsBoxPanel/Empty";
import BsBoxPanel from "@/components/bs/BsBoxPanel";

export default {
  name: "VideoSurveillance",
  data() {
    return {
      loading: true,
      videoList: [],
    };
  },
  components: { cameraVideo, Empty, BsBoxPanel },
  computed: {
    ...mapState(["farmId", "companyId"]),
  },
  created() {
    this.loading = true;
    this.initMoudle();
  },
  methods: {
    async initMoudle() {
      await this.getVideoDetail();

      await this._nextTick();
      this.$refs.cameraVideoRef &&
        (await this.$refs.cameraVideoRef.initModule());
    },

    getMore() {
      location.href = `/index.html#/iot/newiot/company=${this.companyId}&farm=${this.farmId}`;
    },
    async getVideoDetail() {
      try {
        const res = await iotAccess.cameraListService({
          farmId: this.farmId,
          pageNo: 1,
          pageSize: 200,
        });
        res.list.length ? this.videoList.push(res.list[0]) : this.videoList;
        console.log(this.videoList);
      } catch (e) {
        this.videoList = [];
        console.log(e);
      }
      this.loading = false;
    },

    _nextTick(time = 0, cb = () => {}) {
      return new Promise((resolve) => {
        setTimeout(async () => {
          await this.$nextTick();
          await cb();
          resolve(true);
        }, time);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@include bs(wrap) {
  position: relative;
  width: 100%;
  height: 100%;
  padding-left: 10px;
  box-sizing: border-box;

  @include e(headerVideo) {
    margin-top: 10px;
    height: calc(100% - 20px);
  }
  @include e(videoItem) {
    //margin-top: 10px;
    width: 100%;
    height: 100%;
  }
}
</style>
